export const containerClassName =
   'px-3 py-2 rounded-[10px] transition-colors duration-200 mb-1 inline-block w-full'

export const nameAndIconContainerClassName = 'flex items-center'

export const iconContainerClassName = 'mr-12px'

export const nameClassName = 'text-sm-medium truncate flex-1'
